import {Component} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

@Component({
  selector: 'app-product-out-of-stock-modal',
  templateUrl: './product-out-of-stock-modal.component.html',
  styleUrls: ['./product-out-of-stock-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class ProductOutOfStockModalComponent {

}
